module.exports = __webpack_public_path__ + "img/exercise2.5660dbdb.svg";